import { Navigate } from 'react-router';
import { routePaths } from 'utils/constants';

/** NPT-2095 — the admin create-booking wizard was removed; old links land on the trips list. */
const LegacyCreateBookingRedirect = () => <Navigate to={routePaths.ADMIN.MANAGE_TRIP.INDEX} replace />;

export default LegacyCreateBookingRedirect;
